import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const Key = styled.div`
  padding: ${({ theme }) => theme.space.sm} 0;
`;

export const StyledHeading = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.lg};
`;
